export default [
     {
    path: "/bulk-sms-dashboard",
    name: "bulk-sms-dashboard",
    component: () => import('./BulkSMSDash.vue')
  }
]